/**
 * Derive a copy id that does not collide with any existing id in `existingIds`.
 * Pattern: `<id>-copy`, then `<id>-copy-2`, `<id>-copy-3`, …
 * Note: collision avoidance is scoped to the loaded page (limit 100) —
 * acceptable for the demo adapter, documented trade-off.
 */
export function deriveCopyId(baseId: string, existingIds: Set<string>): string {
  const candidate = `${baseId}-copy`
  if (!existingIds.has(candidate)) return candidate
  let n = 2
  while (existingIds.has(`${candidate}-${n}`)) n++
  return `${candidate}-${n}`
}
